/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';
// Local reorder; no server fetch

export const changeOrder = createAsyncThunk(
  'products/changeOrder',
  async ({ assetId, productId, order }, {
    extra: { Logger, Toast, UiBlocker, sdk },
  }) => {
    try {
      UiBlocker.block('Reordering product media…');
      await sdk.assets.changeImageOrder(assetId, productId, order);
      const targetIndex = Number.isFinite(order) ? order : 0;
      Toast('Product media order updated successfully');
      return { productId, assetId, order: targetIndex };
    } catch (error) {
      Logger.error(new Error('Product assets reorder failed'), { error });
      Toast('Failed to update product media order');
      throw error;
    } finally {
      UiBlocker.unblock();
    }
  },
);

export const reducer = (builder) => {
  builder.addCase(
    changeOrder.pending,
    (state, { meta }) => {
      state.isChangingOrder = true;
      state.search.isLoading = true;
    },
  ).addCase(
    changeOrder.fulfilled,
    (state, { payload }) => {
      state.isChangingOrder = false;
      state.search.isLoading = false;
      try {
        const { productId, assetId, order } = payload || {};
        const product = state.items.find((p) => p._id === productId);
        if (!product || !Array.isArray(product.assets)) return;
        const currentIndex = product.assets.findIndex((a) => a._id === assetId);
        if (currentIndex === -1) return;
        const clampedIndex = Math.max(0, Math.min(order, product.assets.length - 1));
        if (currentIndex === clampedIndex) return;
        const [moved] = product.assets.splice(currentIndex, 1);
        product.assets.splice(clampedIndex, 0, moved);

        // Recompute customOrder indexes for all assets in this product
        product.assets.forEach((asset, idx) => {
          if (!Array.isArray(asset.customOrder)) asset.customOrder = [];
          const entryIndex = asset.customOrder.findIndex((co) => co.productId === productId);
          if (entryIndex >= 0) {
            asset.customOrder[entryIndex] = { ...asset.customOrder[entryIndex], productId, index: idx };
          } else {
            asset.customOrder.push({ productId, index: idx });
          }
        });
      } catch (e) {
        // ignore reducer-time reorder errors
      }
    },
  ).addCase(
    changeOrder.rejected,
    (state, { error, meta }) => {
      state.isChangingOrder = false;
      state.search.isLoading = false;
      state.error = error;
    },
  );
};
